<template lang="pug" src="./../views/Footer.pug">
</template>

<script>
  export default {
    name: 'footerbar',
    data() {
      return {};
    },
  };
</script>
<style scoped>
  .footer {
    background-color: #263238;
    color: white;
  }

  .white {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?206a66e3